import React from "react";
import { Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import logoCIE from "../../assets/img/logoCIE.svg";
import backgroundImage from "../../assets/img/FondoDosNuevo.svg";
import logoPreguntas from "../../assets/img/btnPreguntas2.png";
import logoUsers from "../../assets/img/btnUsuarios2.png";
import LogOut from "../../assets/img/btnLogout.png";
import arrowLeft from "../../assets/img/arrowLeft.png";
import HeaderUsuario from "../header/HeaderUsuario";
import logoVideo from "../../assets/img/btnVideo.png";

function AdminPanel() {
  const logout = useLogout();

  const handleLogout = () => {
    logout();
  };

  return (
    <div
      className="min-h-[100dvh] flex flex-col relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Header flotante: más seguro en móvil */}
      <div className="absolute top-3 right-3 sm:top-4 sm:right-4 z-20">
        <HeaderUsuario />
      </div>

      {/* Contenido principal */}
      <div className="flex-grow flex items-center justify-center sm:justify-start px-4 sm:px-16">
        <div className="flex flex-col items-start space-y-6 sm:space-y-8 w-full max-w-3xl min-w-0">
          <h1 className="w-full text-left text-3xl sm:text-5xl leading-tight font-bold text-[#00733A] mb-6 sm:mb-10">
            CONFIGURACIÓN
          </h1>

          {/* Card 1 */}
          <Link
            to="/admin/niveles-preguntas"
            className="group flex items-center justify-between bg-green-700 rounded-lg px-4 sm:px-8 py-4 sm:py-5 transition-transform w-full sm:hover:scale-105 hover:shadow-[0_9px_20px_rgba(0,0,0,0.4)]"
          >
            <div className="flex items-center gap-4 min-w-0">
              <img
                src={logoPreguntas}
                alt="Panel de Preguntas"
                className="w-10 h-10 sm:w-12 sm:h-12 shrink-0 filter brightness-0 invert"
              />
              <span className="text-lg sm:text-2xl lg:text-3xl font-semibold text-white font-montserrat break-words">
                Panel de preguntas
              </span>
            </div>
            <img
              src={arrowLeft}
              alt="Arrow"
              className="h-7 sm:h-8 w-auto shrink-0 filter brightness-0 invert"
            />
          </Link>

          {/* Card 2 */}
          <Link
            to="/admin/lista-usuarios"
            className="group flex items-center justify-between bg-green-700 rounded-lg px-4 sm:px-8 py-4 sm:py-5 transition-transform w-full sm:hover:scale-105 hover:shadow-[0_9px_20px_rgba(0,0,0,0.4)]"
          >
            <div className="flex items-center gap-4 min-w-0">
              <img
                src={logoUsers}
                alt="Opciones de Usuarios"
                className="w-10 h-10 sm:w-11 sm:h-12 shrink-0 filter brightness-0 invert"
              />
              <span className="text-lg sm:text-2xl lg:text-3xl font-semibold text-white font-montserrat break-words">
                Usuarios
              </span>
            </div>
            <img
              src={arrowLeft}
              alt="Arrow"
              className="h-7 sm:h-8 w-auto shrink-0 filter brightness-0 invert"
            />
          </Link>

          {/* Card 3 */}
          <Link
            to="/admin/video-tutorial"
            className="group flex items-center justify-between bg-green-700 rounded-lg px-4 sm:px-8 py-4 sm:py-5 transition-transform w-full sm:hover:scale-105 hover:shadow-[0_9px_20px_rgba(0,0,0,0.4)]"
          >
            <div className="flex items-center gap-4 min-w-0">
              <img
                src={logoVideo}
                alt="Video tutorial"
                className="w-10 h-10 sm:w-12 sm:h-12 shrink-0 filter brightness-0 invert"
              />
              <span className="text-lg sm:text-2xl lg:text-3xl font-semibold text-white font-montserrat break-words">
                Video tutorial
              </span>
            </div>
            <img
              src={arrowLeft}
              alt="Arrow"
              className="h-7 sm:h-8 w-auto shrink-0 filter brightness-0 invert"
            />
          </Link>
        </div>
      </div>

      {/* Logo CIE: tamaño controlado en móvil */}
      <div className="absolute bottom-3 right-3 sm:bottom-8 sm:right-8 z-10">
        <img
          src={logoCIE}
          alt="Logo CIE"
          className="w-24 sm:w-28 md:w-36 h-auto"
        />
      </div>
    </div>
  );
}

export default AdminPanel;
